<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：抽奖码-奖品列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">

      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="奖品分类">
          <el-select size="small" v-model="formInline.type" placeholder="所有分类">
            <el-option label="全部" value=""></el-option>
            <el-option label="月抽奖" value="10"></el-option>
            <el-option label="复活奖" value="20"></el-option>
            <el-option label="豪华奖" value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖品名称"><el-input size="small" v-model="formInline.prize_name" placeholder="请输入奖品名称"></el-input></el-form-item>
        <el-form-item>
          <el-form-item label="奖品状态">
            <el-select size="small" v-model="formInline.is_status" placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option label="启用" value="10"></el-option>
              <el-option label="禁用" value="20"></el-option>

            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/plus/lottery/prize/add'">添加奖品</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="lottery_prize_id" label="ID" width="80"></el-table-column>

          <el-table-column prop="prize_name" label="奖品名称"></el-table-column>

          <el-table-column prop="prize_image" label="奖品图片">
            <template slot-scope="scope">
             <div class="pic" ><img v-img-url="scope.row.image[0].file_path" alt="" style="width: 80px;height: 80px;" /></div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="奖品类型">

            <template slot-scope="scope">
              <span v-if="scope.row.type == 10">月抽奖</span>
              <span v-if="scope.row.type == 20">复活奖</span>
              <span v-if="scope.row.type == 30">豪华奖</span>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="奖品排序" width="80"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
          <el-table-column prop="is_status" label="奖品状态" width="80">

            <template slot-scope="scope">
              <span v-if="scope.row.is_status == 10" class="green"><el-button  type="success" @click="onPrizeStatus(scope.row,20)" v-auth="'/plus/lottery/prize/updatestatus'" style="padding:10px">启用</el-button></span>
              <span v-if="scope.row.is_status == 20"><el-button type="error" @click="onPrizeStatus(scope.row,10)" v-auth="'/plus/lottery/prize/updatestatus'" style="padding:10px">禁用</el-button></span>

            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
             <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/plus/lottery/prize/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/plus/lottery/prize/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>



  </div>
</template>

<script>
import LotteryApi from '@/api/lottery.js';

export default {
  components: {
    /*编辑组件*/

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        type:'',
        prize_name:"",
        is_status:'',
      },

      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: []
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      LotteryApi.prizeList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.gradeList = data.data.grade;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },

    /*打开添加*/
    addClick() {

      this.$router.push('/plus/lottery/prize/add');
    },



    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/plus/lottery/prize/edit',
        query: {
          lottery_prize_id: row.lottery_prize_id,
          scene: 'edit'
        }
      });
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },
    //更改状态
    onPrizeStatus(row,status){

      let self = this;
      LotteryApi.updateStatus({
        lottery_prize_id: row.lottery_prize_id,
        is_status:status
      }, true)
        .then(data => {
          self.getTableList();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          LotteryApi.deletePrice(
            {
              lottery_prize_id: row.lottery_prize_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>
<style>
  .pic{width: 80;height: 80;}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/prize/index.vue